import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Layout from '../components/Layout';
import { useAuth } from '../context/AuthContext';

const STATUS_COLORS = { building:'#E6F1FB', submitted:'#FAEEDA', approved:'#EAF3DE', staged:'#EEEDFE', checked_out:'#F1EFE8', denied:'#FCEBEB' };
const STATUS_TEXT = { building:'#0C447C', submitted:'#854F0B', approved:'#27500A', staged:'#3C3489', checked_out:'#5F5E5A', denied:'#A32D2D' };

export default function PullListsPage() {
  const { user } = useAuth();
  const [lists, setLists] = useState([]);
  const [sites, setSites] = useState([]);
  const [items, setItems] = useState([]);
  const [showNew, setShowNew] = useState(false);
  const [form, setForm] = useState({ name:'', site_id:'', mode:'fluid', pickup_date:'', notes:'', items:[] });
  const [itemSearch, setItemSearch] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [msg, setMsg] = useState('');

  const load = () => {
    axios.get('/api/pull-lists').then(r => setLists(r.data)).catch(()=>{});
    axios.get('/api/auth/me').then(r => setSites(r.data.sites || [])).catch(()=>{});
  };

  useEffect(() => { load(); }, []);

  const searchItems = () => {
    axios.get('/api/inventory', { params: { search: itemSearch } }).then(r => setSearchResults(r.data)).catch(()=>{});
  };

  const addItem = (item) => {
    if (form.items.find(i => i.item_id === item.id)) return;
    setForm({ ...form, items: [...form.items, { item_id: item.id, name: item.name, sku: item.sku, quantity: 1 }] });
  };

  const submit = async () => {
    if (!form.name || !form.site_id || !form.items.length) { setMsg('Fill in name, site, and add at least one item'); return; }
    try {
      await axios.post('/api/pull-lists', { ...form, items: form.items.map(i => ({ item_id: i.item_id, quantity: i.quantity })) });
      setMsg('Pull list created!'); setShowNew(false); setForm({ name:'', site_id:'', mode:'fluid', pickup_date:'', notes:'', items:[] }); load();
    } catch(e) { setMsg(e.response?.data?.error || 'Failed'); }
  };

  const approve = async (id) => {
    await axios.patch(`/api/pull-lists/${id}/approve`); load();
  };

  const deny = async (id) => {
    const reason = prompt('Reason for denial?');
    await axios.patch(`/api/pull-lists/${id}/deny`, { reason }); load();
  };

  const canApprove = ['general_manager','project_manager','warehouse_manager'].includes(user?.role);
  const canCreate = ['general_manager','project_manager','warehouse_manager','foreman'].includes(user?.role);

  return (
    <Layout>
      <div style={{marginBottom:'20px',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div>
          <h1 style={{fontSize:'20px',fontWeight:'700',color:'#0C447C',margin:0}}>Pull lists</h1>
          <p style={{color:'#888',fontSize:'13px',marginTop:'4px'}}>{lists.length} lists</p>
        </div>
        {canCreate && <button onClick={()=>setShowNew(!showNew)} style={{padding:'9px 18px',background:'#0C447C',color:'#fff',border:'none',borderRadius:'8px',fontSize:'13px',fontWeight:'600',cursor:'pointer'}}>+ New pull list</button>}
      </div>
      {msg && <div style={{background:'#EAF3DE',borderRadius:'8px',padding:'10px 14px',color:'#27500A',fontSize:'13px',marginBottom:'14px'}}>{msg}</div>}

      {showNew && (
        <div style={{background:'#fff',borderRadius:'12px',border:'2px solid #185FA5',padding:'20px',marginBottom:'20px'}}>
          <h2 style={{fontSize:'14px',fontWeight:'700',color:'#0C447C',marginBottom:'14px'}}>New pull list</h2>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px',marginBottom:'12px'}}>
            <div>
              <label style={{display:'block',fontSize:'11px',color:'#666',fontWeight:'600',marginBottom:'4px'}}>List name</label>
              <input value={form.name} onChange={e=>setForm({...form,name:e.target.value})} placeholder="e.g. Monday morning setup"
                style={{width:'100%',padding:'8px 10px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px'}} />
            </div>
            <div>
              <label style={{display:'block',fontSize:'11px',color:'#666',fontWeight:'600',marginBottom:'4px'}}>Job site</label>
              <select value={form.site_id} onChange={e=>setForm({...form,site_id:e.target.value})} style={{width:'100%',padding:'8px 10px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px'}}>
                <option value="">— Select site —</option>
                {sites.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
              </select>
            </div>
            <div>
              <label style={{display:'block',fontSize:'11px',color:'#666',fontWeight:'600',marginBottom:'4px'}}>Pickup date</label>
              <input type="date" value={form.pickup_date} onChange={e=>setForm({...form,pickup_date:e.target.value})} style={{width:'100%',padding:'8px 10px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px'}} />
            </div>
            <div>
              <label style={{display:'block',fontSize:'11px',color:'#666',fontWeight:'600',marginBottom:'4px'}}>Mode</label>
              <select value={form.mode} onChange={e=>setForm({...form,mode:e.target.value})} style={{width:'100%',padding:'8px 10px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px'}}>
                <option value="fluid">No approval required — fluid</option>
                <option value="managed">Approval required — managed</option>
              </select>
            </div>
          </div>
          <div style={{marginBottom:'12px'}}>
            <label style={{display:'block',fontSize:'11px',color:'#666',fontWeight:'600',marginBottom:'4px'}}>Add items</label>
            <div style={{display:'flex',gap:'8px',marginBottom:'8px'}}>
              <input value={itemSearch} onChange={e=>setItemSearch(e.target.value)} onKeyDown={e=>e.key==='Enter'&&searchItems()}
                placeholder="Search inventory..." style={{flex:1,padding:'7px 10px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px'}} />
              <button onClick={searchItems} style={{padding:'7px 14px',background:'#185FA5',color:'#fff',border:'none',borderRadius:'8px',fontSize:'12px',cursor:'pointer'}}>Search</button>
            </div>
            <div style={{display:'flex',flexWrap:'wrap',gap:'6px'}}>
              {searchResults.map((item,i) => (
                <button key={i} onClick={()=>addItem(item)} style={{padding:'5px 12px',background:'#E6F1FB',color:'#0C447C',border:'1px solid #B5D4F4',borderRadius:'20px',fontSize:'12px',cursor:'pointer'}}>
                  + {item.name} ({item.quantity_available} avail)
                </button>
              ))}
            </div>
          </div>
          {form.items.length > 0 && (
            <div style={{marginBottom:'12px'}}>
              <div style={{fontSize:'11px',color:'#666',fontWeight:'600',marginBottom:'6px'}}>Items ({form.items.length})</div>
              {form.items.map((item,i) => (
                <div key={i} style={{display:'flex',alignItems:'center',gap:'10px',padding:'6px 10px',background:'#f8f8f8',borderRadius:'6px',marginBottom:'4px',fontSize:'13px'}}>
                  <span style={{flex:1}}>{item.name}</span>
                  <input type="number" min="1" value={item.quantity} onChange={e=>{
                    const updated=[...form.items]; updated[i].quantity=parseInt(e.target.value); setForm({...form,items:updated});
                  }} style={{width:'60px',padding:'4px 8px',border:'1px solid #ddd',borderRadius:'6px',fontSize:'12px'}} />
                  <button onClick={()=>setForm({...form,items:form.items.filter((_,j)=>j!==i)})} style={{background:'none',border:'none',color:'#A32D2D',cursor:'pointer',fontSize:'16px'}}>×</button>
                </div>
              ))}
            </div>
          )}
          <div style={{display:'flex',gap:'8px',justifyContent:'flex-end'}}>
            <button onClick={()=>setShowNew(false)} style={{padding:'8px 16px',background:'#fff',border:'1px solid #ddd',borderRadius:'8px',fontSize:'13px',cursor:'pointer'}}>Cancel</button>
            <button onClick={submit} style={{padding:'8px 16px',background:'#0C447C',color:'#fff',border:'none',borderRadius:'8px',fontSize:'13px',fontWeight:'600',cursor:'pointer'}}>Create pull list</button>
          </div>
        </div>
      )}

      {lists.map((list,i) => (
        <div key={i} style={{background:'#fff',borderRadius:'12px',border:'1px solid #eee',padding:'16px 20px',marginBottom:'10px',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
          <div>
            <div style={{fontWeight:'700',fontSize:'14px',color:'#222',marginBottom:'2px'}}>{list.name}</div>
            <div style={{fontSize:'12px',color:'#888'}}>{list.site_name} · {list.first_name} {list.last_name} · {list.item_count} items
              {list.pickup_date && ` · Pickup ${new Date(list.pickup_date).toLocaleDateString()}`}
            </div>
          </div>
          <div style={{display:'flex',gap:'8px',alignItems:'center'}}>
            <span style={{background:STATUS_COLORS[list.status]||'#f0f0f0',color:STATUS_TEXT[list.status]||'#555',padding:'4px 12px',borderRadius:'20px',fontSize:'12px',fontWeight:'600',textTransform:'capitalize'}}>
              {list.status}
            </span>
            {canApprove && list.status === 'submitted' && (
              <>
                <button onClick={()=>approve(list.id)} style={{padding:'6px 12px',background:'#3B6D11',color:'#fff',border:'none',borderRadius:'6px',fontSize:'12px',cursor:'pointer'}}>Approve</button>
                <button onClick={()=>deny(list.id)} style={{padding:'6px 12px',background:'#A32D2D',color:'#fff',border:'none',borderRadius:'6px',fontSize:'12px',cursor:'pointer'}}>Deny</button>
              </>
            )}
          </div>
        </div>
      ))}
      {lists.length === 0 && <div style={{textAlign:'center',padding:'40px',color:'#888',background:'#fff',borderRadius:'12px',border:'1px solid #eee'}}>No pull lists yet</div>}
    </Layout>
  );
}
